import { render, staticRenderFns } from "./AboutWeThink.vue?vue&type=template&id=667c5c28&scoped=true"
import script from "./AboutWeThink.vue?vue&type=script&lang=ts"
export * from "./AboutWeThink.vue?vue&type=script&lang=ts"
import style0 from "./AboutWeThink.vue?vue&type=style&index=0&id=667c5c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c5c28",
  null
  
)

export default component.exports